"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO INFORMACION_ADICIONAL DE ROAMING
 * @param {object} fields
 * @returns
 */
const bonosInfoNormalizer = (data) => {
    var _a;
    try {
        let res = null;
        const listBonos = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.listBonos;
        if (listBonos && Array.isArray(listBonos) && listBonos.length > 0) {
            const normalizedInfo = [];
            listBonos.map((item, index) => {
                const { listadoBonosCards, paises, pagesAlias, typeMovil, subTitle } = item.fields;
                const result = {};
                const bonoList = [];
                listadoBonosCards.map((bono, index) => {
                    const bonoCard = {};
                    const { altSEO, bandaPromo, imgSrc, labelCard, prePrice, price, title, titleSEO, unityCrossedPrice, unityPrice, description, btn, link } = bono.fields;
                    if (title) {
                        bonoCard["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
                    }
                    if (description) {
                        const newDescription = `<ul><li>${description.join('</li><li>')}</li></ul>`;
                        bonoCard['Text-2'] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: newDescription });
                    }
                    if (price) {
                        bonoCard["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), { price: price, currency: unityPrice });
                    }
                    if (bandaPromo) {
                        bonoCard["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: bandaPromo });
                    }
                    if (labelCard) {
                        bonoCard["Label-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-2"]), { label: labelCard });
                    }
                    if (prePrice) {
                        bonoCard["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), { price: prePrice });
                    }
                    if (unityCrossedPrice) {
                        bonoCard["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: unityCrossedPrice });
                    }
                    if (link && link.fields && link.fields.href) {
                        bonoCard["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-3"]), link.fields);
                        bonoCard["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: link.fields.href, title: title || "" });
                    }
                    if (btn && btn.fields && btn.fields.href) {
                        bonoCard["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), btn.fields);
                    }
                    bonoList.push(Object.assign({}, bonoCard));
                });
                result.paises = paises;
                result.pagesAlias = pagesAlias;
                result.typeMovil = typeMovil;
                if (subTitle) {
                    result.subTitle = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: subTitle });
                }
                result.bonos = bonoList;
                normalizedInfo.push(result);
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = bonosInfoNormalizer;
//# sourceMappingURL=index.js.map